import { RelationShipTypeViewModel } from '../../models/Entities/Person/RelationshipType/RelationshipTypeModels';
import { CommonState } from '../common/state/commonState';

export interface PersonRelationshipTypeState extends CommonState<RelationShipTypeViewModel> {
    lastCreated?: RelationShipTypeViewModel;
}

export const PersonRelationshipTypeUnloadState: PersonRelationshipTypeState = {
    isLoadingAll: false,
    successLoadingAll: undefined,
    failOnLoadingAll: false,

    isLoadingOne: false,
    successLoadingOne: undefined,
    failOnLoadingOne: false,

    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,

    isDeletingOne: false,
    successDeletingOne: undefined,
    failOnDeletingOne: false,

    list: [],
    error: undefined,
    lastCreated: undefined
};
